import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import { useSelector } from 'hooks/redux'
import { Header, Radio, Table } from 'components/patterns'
import { getLocationDetails } from 'selectors/dash'
import withStyle, {
  StyledModalContent,
  StyledCustomSwitchGraphicsModal,
  SearchWrapper,
  SearchLabel,
  SearchInputField,
  TableContainer,
  ErrorIcon,
  HeaderContainer,
  CancelIcon,
  RadioButtonContainer,
} from './SelectLocationDetailsModal.style'

const SelectLocationDetailsModal = (props) => {
  const { isOpen, onClickSelect, onClickCancel, panelNumber } = props
  const [searchString, setSearchString] = useState('')
  const [dataSource, setDataSource] = useState([])
  const [selectedType, setSelectedType] = useState()
  const [selectedDetail, setSelectedDetail] = useState()
  const locationDetailsList = useSelector(getLocationDetails)

  useEffect(() => {
    setDataSource(locationDetailsList)
  }, [locationDetailsList])

  const handleSelectClick = () => {
    onClickSelect(selectedDetail, selectedType)
  }

  const handleOnChange = ({ target: { value } }) => {
    setSearchString(value)
  }

  const handleOnClear = () => {
    setSearchString('')
    setDataSource(locationDetailsList)
  }

  const handleSubmitSearch = () => {
    const regex = new RegExp(searchString, 'i')
    const result = locationDetailsList.filter(({ type }) => regex.test(type))
    setDataSource(result)
  }

  const isSelectDisabled = () => {
    return !selectedDetail
  }

  const handleSelectLocationType = (detail, type) => {
    setSelectedDetail(detail)
    setSelectedType(type)
  }

  const columns = [
    {
      key: 0,
      dataIndex: 'detail',
      sortDirections: ['ascend', 'descend'],
      width: 70,
      render: (detail, record) => {
        const { type } = record
        const match = selectedDetail === detail

        return (
          <RadioButtonContainer>
            <Radio
              onClick={() => handleSelectLocationType(detail, type)}
              checked={match}
            />
          </RadioButtonContainer>
        )
      },
    },
    {
      key: 1,
      title: strings.detail_title,
      dataIndex: 'detail',
      width: 90,
    },
    {
      key: 2,
      title: strings.type_cap,
      dataIndex: 'type',
    },
  ]

  const modalHeader = (
    <HeaderContainer>
      <ErrorIcon
        icon="alert_exclamation_triangle_solid"
        fill="warningPrimary"
      />
      <Header type="h2">
        {panelNumber}{' '}
        {strings.requires_location_and_detail_type_to_place_on_a_panel}
      </Header>
      <CancelIcon onClick={onClickCancel} icon="cancel" />
    </HeaderContainer>
  )

  return (
    <StyledCustomSwitchGraphicsModal
      header={modalHeader}
      isOpen={isOpen}
      size="large"
      customButtons={[
        {
          text: strings.cancel,
          onClick: onClickCancel,
          type: 'secondary',
        },
        {
          text: strings.select,
          onClick: handleSelectClick,
          disabled: isSelectDisabled(),
          type: 'primary',
        },
      ]}
    >
      <StyledModalContent>
        <SearchWrapper>
          <SearchLabel>
            <Header type="h3">
              {strings.search_using_location_type_description}
            </Header>
          </SearchLabel>
          <SearchInputField
            size="large"
            value={searchString}
            onChange={handleOnChange}
            onClear={handleOnClear}
            onSearch={() => handleSubmitSearch()}
            placeholder={strings.enter_search_term}
          />
        </SearchWrapper>
        <TableContainer>
          <Table
            columns={columns}
            dataSource={dataSource}
            pagination={false}
            yScroll={400}
          />
        </TableContainer>
      </StyledModalContent>
    </StyledCustomSwitchGraphicsModal>
  )
}

SelectLocationDetailsModal.propTypes = {
  isOpen: PropTypes.bool,
  panelNumber: PropTypes.string,
  onClickCancel: PropTypes.func,
  onClickSelect: PropTypes.func,
  location: PropTypes.object,
}

export default withStyle(SelectLocationDetailsModal)
